"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var HabitatUndo_exports = {};
__export(HabitatUndo_exports, {
  default: () => HabitatUndo_default
});
module.exports = __toCommonJS(HabitatUndo_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.16797 4C5.16797 3.85677 5.11589 3.73958 5.01172 3.64844C4.92057 3.54427 4.80339 3.49219 4.66016 3.49219C4.52995 3.49219 4.41276 3.54427 4.30859 3.64844C4.21745 3.73958 4.17188 3.85677 4.17188 4V7.75C4.17188 7.9974 4.25651 8.21224 4.42578 8.39453C4.60807 8.57682 4.82943 8.66797 5.08984 8.66797H8.83984C8.97005 8.66797 9.08073 8.6224 9.17188 8.53125C9.27604 8.42708 9.32812 8.30339 9.32812 8.16016C9.32812 8.02995 9.27604 7.91927 9.17188 7.82812C9.08073 7.72396 8.97005 7.67188 8.83984 7.67188H5.75391C6.23568 6.85156 6.91927 6.1875 7.80469 5.67969C8.6901 5.17188 9.64714 4.91797 10.6758 4.91797C11.457 4.91797 12.1797 5.0612 12.8438 5.34766C13.5208 5.64714 14.1133 6.05078 14.6211 6.55859C15.1289 7.05339 15.526 7.63281 15.8125 8.29688C16.099 8.97396 16.2422 9.69661 16.2422 10.4648C16.2422 11.2201 16.099 11.9362 15.8125 12.6133C15.526 13.2904 15.1289 13.8828 14.6211 14.3906C14.1133 14.8854 13.5208 15.276 12.8438 15.5625C12.1797 15.849 11.457 15.9922 10.6758 15.9922C9.97266 15.9922 9.30208 15.8685 8.66406 15.6211C8.03906 15.3737 7.47917 15.0352 6.98438 14.6055C6.48958 14.1628 6.08594 13.6484 5.77344 13.0625C5.44792 12.4766 5.24609 11.8385 5.16797 11.1484C5.14193 11.0182 5.07682 10.9141 4.97266 10.8359C4.86849 10.7448 4.74479 10.7057 4.60156 10.7188C4.47135 10.7318 4.36068 10.7969 4.26953 10.9141C4.19141 11.0182 4.15885 11.1419 4.17188 11.2852C4.27604 12.0924 4.51693 12.8411 4.89453 13.5312C5.27214 14.2344 5.7474 14.8464 6.32031 15.3672C6.90625 15.875 7.57031 16.2721 8.3125 16.5586C9.05469 16.8581 9.84245 17.0078 10.6758 17.0078C11.5872 17.0078 12.4401 16.832 13.2344 16.4805C14.0286 16.1419 14.7253 15.6797 15.3242 15.0938C15.9232 14.4948 16.3919 13.7982 16.7305 13.0039C17.082 12.2096 17.2578 11.3633 17.2578 10.4648C17.2578 9.55339 17.082 8.70052 16.7305 7.90625C16.3919 7.11198 15.9232 6.42188 15.3242 5.83594C14.7253 5.23698 14.0286 4.76823 13.2344 4.42969C12.4401 4.09115 11.5872 3.92188 10.6758 3.92188C10.1289 3.92188 9.58854 3.98698 9.05469 4.11719C8.52083 4.2474 8.01302 4.4362 7.53125 4.68359C7.0625 4.93099 6.6263 5.22396 6.22266 5.5625C5.81901 5.91406 5.46745 6.30469 5.16797 6.73438V4Z",
      fill: "currentColor"
    }
  )
);
const SvgHabitatUndo = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var HabitatUndo_default = SvgHabitatUndo;
